import {getAllExports, getSingleExport} from '../../services/ExportsService';

export default {
  namespaced: true,
  state: {
    exportsList: []
  },
  getters: {
    exportsList: (state) => {
      return state.exportsList;
    }
  },
  mutations: {
    setExportsList (state, exports) {
      state.exportsList = exports;
    }
  },
  actions: {
    async loadExportsList ({commit}, clientId = null) {
      try {
        let exportsList = [];
        if (clientId) {
          const allExports = await getAllExports(clientId);
          exportsList = allExports.data;
        }
        commit('setExportsList', exportsList.data, global);
      } catch (error) {
        console.log(error);
        throw error;
      }
    }
  },
  async loadSingleExport ({commit}, exportId = null) {
    try {
      let exportSingle = null;
      if (exportId) {
        const singleExport = await getSingleExport(exportId);
        exportSingle = singleExport.data;
      }
      commit('setExportSingle', exportSingle.data, global);
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/exportsModule.js